import { isWaivedInterestPayOffEligible } from '../../helpers/parseEligibility';
import { t } from '../../strings/i18n';
import { required } from '../../xform';
const paymentAmountConfig = (apiMachineRef) => {
    const api = apiMachineRef.getSnapshot().context;
    const accountSummary = api.accountSummaryQueryResult.data;
    const paymentEnterpriseEligibility = api.paymentEnterpriseEligibilityQueryResult.data;
    const payOffAmount = isWaivedInterestPayOffEligible(paymentEnterpriseEligibility)
        ? accountSummary.billing.waivedInterest.payOffBalance
        : accountSummary.credit.currentBalance;
    return [
        'paymentAmount',
        payOffAmount,
        'ENABLED',
        [required(t('errors.payoffAmountDate'))]
    ];
};
export default paymentAmountConfig;
